export const propertiesEnum = {
  TimeReference: 'TimeReference',
  Days: 'Days',
  Percent: 'Percent',
  Amount: 'Amount',
  CurrencyId: 'CurrencyId',
  AmountOrPercentInDeposits: 'AmountOrPercentInDeposits'
};

export const sourceEnum = {
  deposits: 'deposits',
  cancellations: 'cancellations',
};

